import ToolboxIcon from './component.jsx'
export default ToolboxIcon
